export const ActionType = {
  SET_PRODUCTS: "SELECTED_PRODUCTS",
  SELECTED_PRODUCTS: "SELECTED_PRODUCTS",
  CHECK_LOGIN: " CHECK_LOGIN",
  DISPLAY_FRUITS: " DISPLAY_FRUITS",
  DISPLAY_VEGGIES: "DISPLAY_VEGGIES",
};
